import React from 'react'
import styles from './loading-screen.styles'
import injectSheet from 'react-jss'
import Bone from 'pobble-components/dist/bone'

const Row = injectSheet(({ BREAKPOINTS }) => ({
  row: {
    padding: '20px 0',
    borderBottom: '1px solid #eee',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    columnGap: '20px',
    alignItems: 'end',
    [`@media (max-width: ${BREAKPOINTS.XS})`]: {
      display: 'block',
      padding: '20px 0'
    }
  }
}))(({ classes, children }) => <div className={classes.row}>{children}</div>)

const InputCell = injectSheet(({ BREAKPOINTS }) => ({
  container: {
    [`@media (max-width: ${BREAKPOINTS.XS})`]: {
      margin: '20px 0 0',
      '&:first-child': {
        margin: '0'
      }
    }
  },
  label: {
    height: '16px !important',
    marginBottom: '6px'
  },
  input: {
    display: 'block !important',
    width: '100% !important',
    borderRadius: '4px !important',
    height: '40px !important'
  }
}))(({ labelWidth, classes }) => (
  <div className={classes.container}>
    <Bone className={classes.label} style={{ width: labelWidth }} />
    <Bone className={classes.input} />
  </div>
))

const HintCell = injectSheet(({ BREAKPOINTS }) => ({
  container: {
    [`@media (max-width: ${BREAKPOINTS.XS})`]: {
      margin: '20px 0 0'
    }
  }
}))(({ fLineWidth, sLineWidth, classes }) => (
  <div
    className={classes.container}
    style={{ height: '40px', display: 'flex' }}>
    <span
      style={{
        width: '5px',
        height: '40px',
        marginRight: '10px',
        borderRadius: '10px',
        backgroundColor: '#ececec'
      }}
    />
    <div
      style={{
        flex: '1',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
      }}>
      <Bone style={{ height: '8px', width: fLineWidth, marginBottom: '4px' }} />
      <Bone style={{ height: '8px', width: sLineWidth }} />
    </div>
  </div>
))

const LoadingScreen = ({ classes }) => (
  <div className={classes.container}>
    <div
      style={{
        height: '140px',
        margin: '-22px -22px 0',
        borderBottom: '1px solid #eee',
        display: 'flex',
        alignItems: 'center',
        padding: '22px'
      }}>
      <Bone
        style={{
          width: '96px',
          height: '96px',
          borderRadius: '96px',
          marginRight: '20px'
        }}
      />
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Bone style={{ width: '160px', height: '16px', marginBottom: '8px' }} />
        <Bone style={{ width: '80px', height: '12px' }} />
      </div>
    </div>
    <div
      style={{
        marginTop: '20px',
        display: 'flex',
        justifyContent: 'space-between'
      }}>
      <Bone style={{ width: '150px', height: '25px' }} />
      <Bone style={{ width: '120px', height: '40px', borderRadius: '4px' }} />
    </div>
    <Row>
      <InputCell labelWidth="80px" />
      <InputCell labelWidth="80px" />
      <HintCell fLineWidth="100%" sLineWidth="50%" />
    </Row>
    <Row>
      <InputCell labelWidth="100px" />
      <div />
      <HintCell fLineWidth="100%" sLineWidth="80%" />
    </Row>
    <Row>
      <InputCell labelWidth="70px" />
      <InputCell labelWidth="0" />
      <HintCell fLineWidth="100%" sLineWidth="10%" />
    </Row>
    <Row>
      <InputCell labelWidth="75px" />
      <InputCell labelWidth="0" />
      <HintCell fLineWidth="100%" sLineWidth="0" />
    </Row>
    <Row>
      <InputCell labelWidth="75px" />
      <div />
      <HintCell fLineWidth="80%" sLineWidth="0" />
    </Row>
    <Row>
      <InputCell labelWidth="60px" />
      <InputCell labelWidth="0" />
      <HintCell fLineWidth="100%" sLineWidth="80%" />
    </Row>
  </div>
)

export default injectSheet(styles)(LoadingScreen)
